module.exports = __webpack_public_path__ + "static/media/kr.50960802.svg";